import { debounce } from 'lodash';

export function getCookie(name: string): string {
    let cookieValue: string | null = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue || '';
}

/**
 * Debounce a method
 */
export function Debounce(ms: number) {
    return function (target: any, key: any, descriptor: any) {
        const oldFunc = descriptor.value
        const newFunc = debounce(oldFunc, ms)
        descriptor.value = function () {
            return newFunc.apply(this, arguments as any)
        }
    }
}